// Alternating rather than concatenating, so the six card cap cannot fill entirely with
// Roadtrip Nation, which returns many interviews per career where CareerOneStop returns one.
export const interleaved = <T>(first: readonly T[], second: readonly T[]): T[] => {
    const merged: T[] = [];

    for (let i = 0; i < Math.max(first.length, second.length); i += 1) {
        if (i < first.length) {
            merged.push(first[i]);
        }
        if (i < second.length) {
            merged.push(second[i]);
        }
    }

    return merged;
};
